var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-builder"},[(_vm.errorsPresent)?_c('UnrecoverableErrors'):(_vm.interfaceState === 'normal')?_c('BuilderLayout'):(_vm.interfaceState === 'loading')?_c('Loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }